export const routes = (prefix=`reports`, pre=`patients`) => [
    {
        name: `${prefix}.${pre}.op-diagnosis-report.index`,
        path: `/${prefix}/${pre}/op-diagnosis-report`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.op-diagnosis-report.index`,
                PageDescription: "Patient Reports: OP Diagnosis report",
            },
        },
    },
    {
        name: `${prefix}.${pre}.print.op-diagnosis-report.index`,
        path: `/${prefix}/${pre}/op-diagnosis-report/print`,
        component: () => import('./prints/OPDiagnosisReport.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.op-diagnosis-report.index`,
                PageDescription: "Patient Reports: OP Diagnosis report",
            },
            print: true,
        },
    },
    {
        name: `${prefix}.${pre}.print.patient-charges.index`,
        path: `/${prefix}/${pre}/patient-charges/print`,
        component: () => import('./prints/PatientCharges.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.op-diagnosis-report.index`,
                PageDescription: "Patient Reports: OP Diagnosis report",
            },
            print: true,
        },
    },
];